export const appABMAssignments = {
    read(appId, options) {
        return $.getJSON(AdminRoutes.adminAppABMAssignmentsPath(appId, options));
    },

    destroyMultiple(appId, ids) {
        return $.ajax({
            method:      'POST',
            dataType:    'json',
            contentType: "application/json",
            url:         AdminRoutes.revokeMultipleAdminAppABMAssignmentsPath(appId),
            data:        JSON.stringify({ ids })
        })
    },
}